export enum OfferType {
  ELECTRICITY = 'Electricity',
  GAS = 'Gas',
  BOTH = 'Electricity&Gas',
}
